import { z } from 'zod';
import { isValidEmailAddress } from './email.js';
export const PRINT_SHOP_EMAIL_FORMAT_ERROR = 'Enter one email address, for example print@example.com.';
export const printShopEmailSchema = z
    .string()
    .trim()
    .refine((value) => value === '' || isValidEmailAddress(value), {
    message: PRINT_SHOP_EMAIL_FORMAT_ERROR,
});
export const printShopSendStatusSchema = z.enum([
    'queued',
    'sending',
    'sent',
    'recorded',
    'failed',
    'unknown',
    'partial',
]);
export const printShopPartStatusSchema = z.enum([
    'queued',
    'sending',
    'sent',
    'recorded',
    'empty',
    'failed',
    'unknown',
]);
const PRINT_SHOP_PART_DONE = {
    queued: false,
    sending: false,
    sent: true,
    recorded: true,
    empty: true,
    failed: false,
    unknown: false,
};
export function isPrintShopPartDone(status) {
    return PRINT_SHOP_PART_DONE[status];
}
const lineIds = {
    occurrenceDisplayId: z.string().min(1),
    propertyDisplayId: z.string().min(1),
};
const quickBooksLine = {
    ...lineIds,
    qboInvoiceId: z.string().min(1),
    docNumber: z.string().optional(),
    customerName: z.string().optional(),
};
export const printShopInvoiceLineSchema = z.discriminatedUnion('outcome', [
    z.object({ outcome: z.literal('pending'), ...quickBooksLine }),
    z.object({ outcome: z.literal('included'), ...quickBooksLine }),
    z.object({ outcome: z.literal('failed'), ...quickBooksLine, errorMessage: z.string() }),
    z.object({ outcome: z.literal('skipped_closed'), ...lineIds }),
    z.object({ outcome: z.literal('not_found'), ...lineIds }),
    z.object({ outcome: z.literal('no_qbo_invoice'), ...lineIds }),
    z.object({ outcome: z.literal('deleted_in_qbo'), ...lineIds }),
]);
export const PRINT_SHOP_MAX_PART_INVOICES = 100;
export const MAX_PRINT_SHOP_SEND = 500;
export const printShopInvoiceLinesSchema = z.array(printShopInvoiceLineSchema);
//# sourceMappingURL=printShop.js.map